/**
 * TUS ITEMS Y PRECIOS COMO LISTA (MAD-MIS-ITEMS-VISTA-T1, maqueta 4pEwA37HR3BTGuvfy2EUZR propuesta A, SI de Josse #43980).
 *
 * Lo que pinta cada fila, sin DOM: el nombre corto (lo que distingue al item dentro de su linea, la misma regla de las
 * tarjetas del Cual del asistente), el tipo si el corto no lo dice, el precio por unidad con "por confirmar" y lo que
 * incluye o no incluye cuando hay gemelas. El corto se calcula sobre la linea ENTERA, no sobre lo filtrado: buscar no
 * cambia como se llama cada fila. El nombre escrito a mano (nexo-api 795) gana, como en la tarjeta del Cual.
 * Lo prueba scripts/check-lista-items.mjs.
 *
 * @module application/presupuestos/listaDeItems
 */
import { catalogoDeItems, precioDeEstandar } from './itemEstandar.js';
import { etiquetasCortas } from './asistentePasos.js';

const texto = (v) => (v === null || v === undefined ? '' : String(v).trim());

/**
 * El nombre y lo extra de cada estandar de una linea completa: Map id -> { corto, extra }.
 * MAD-EDICION-COHERENTE-T1 (GO #44415): un item, un nombre. corto = el nombre del item (el escrito a mano o el armado,
 * que desde nexo-api 804/036 no lleva la linea ni el precio): el mismo en la tarjeta, Tus items, el editor, la partida
 * y el PDF. Antes era otro texto armado con lo que distingue (etiquetasCortas); ese queda solo para lo extra que
 * separa a dos gemelos ('incluye ...') y como respaldo si un item no trae nombre.
 */
export function cortosDeLinea(linea) {
  const est = (linea && linea.estandar) || [];
  const { cortas } = etiquetasCortas(est.map((e) => ({ etiqueta: e.nombre, estandar: e })), linea && linea.plantilla);
  return new Map(est.map((e, k) => [e.id, { corto: nombreDelItem(e) || texto(cortas[k] && cortas[k].corto), extra: texto(cortas[k] && cortas[k].extra) }]));
}

/** El unico nombre de un item: el escrito a mano o el armado (la base ya da nombre = coalesce(manual, armado)). */
export function nombreDelItem(e) {
  return texto(e && e.nombreManual) || texto(e && e.nombre);
}

/**
 * La lista como la pinta la vista: { cuentas, total, visibles, secciones: [{ capitulo, nombre, cuantos, lineas: [{ n, linea,
 * filas: [{ id, nombre, corto, extra, tipo, precio, porConfirmar, unidad }] }] }], porClasificar }.
 * estado = { filtro, buscar } como catalogoDeItems.
 */
export function listaDeItems(lectura, estado = {}) {
  const cat = catalogoDeItems(lectura, estado);
  const completas = new Map(((lectura && lectura.capitulos) || []).flatMap((c) => c.lineas).map((l) => [l.n, l]));
  let visibles = 0;
  const secciones = cat.secciones.map((s) => {
    const lineas = s.lineas.map((l) => {
      const cortos = cortosDeLinea(completas.get(l.n));
      const filas = l.estandar.map((e) => {
        const c = cortos.get(e.id) || { corto: texto(e.nombre), extra: '' };
        const p = precioDeEstandar(e);
        const tipo = texto(e.tipo);
        return {
          id: e.id, nombre: texto(e.nombre), corto: c.corto, extra: c.extra,
          tipo: tipo && !c.corto.toLowerCase().includes(tipo.toLowerCase()) ? tipo : '',
          precio: p.valor, porConfirmar: p.porConfirmar, unidad: e.unidad
        };
      });
      return { n: l.n, linea: l.linea, filas };
    });
    const cuantos = lineas.reduce((a, l) => a + l.filas.length, 0);
    visibles += cuantos;
    return { capitulo: s.capitulo, nombre: s.nombre, cuantos, lineas };
  });
  return { cuentas: cat.cuentas, total: cat.cuentas.todos, visibles, secciones, porClasificar: cat.porClasificar };
}
